module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/4-03606ceb349db5cd548812d0c43a728a.webp";